import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=08ee7bdd&scoped=true&"
import script from "./GroupModal.vue?vue&type=script&lang=ts&"
export * from "./GroupModal.vue?vue&type=script&lang=ts&"
import style0 from "./GroupModal.vue?vue&type=style&index=0&id=08ee7bdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee7bdd",
  null
  
)

export default component.exports